import React from "react";
import { NavLink } from "react-router-dom";

export default function Sidebar({ title, menuItems, basePath }) {
  return (
    <aside
      className="w-fit rounded-[20px] border border-[#0075FF1A]"
      style={{
        boxShadow: "2px 4px 10px 0px #0000000A",
      }}
    >
      <h1 className="w-full min-w-[280px] text-nowrap border-b border-[#0075FF1A] pb-[10px] pl-[20px] pr-[25px] pt-[20px] text-left font-outfit text-[20px] font-medium leading-[25.2px] text-[#222222]">
        {title}
      </h1>

      <div className="custom-scrollbar h-[calc(100vh-250px)] overflow-y-auto">
        {menuItems.map((item, index) => (
          <NavLink
            key={index}
            to={`/${item.value}`}
            end={item.value === basePath} // Adjust for root paths
            className={({ isActive }) =>
              `mb-[6px] mt-[0px] flex cursor-pointer flex-col py-[10px] pl-[26px] text-left font-outfit text-[16px] font-medium leading-[20.16px] first:mt-[10px] last:mb-[21px] ${
                isActive
                  ? "rounded-[5px] border-l-4 border-[#0075FF] bg-[#0075FF1A] text-[#0075FF]"
                  : "border-l-4 border-transparent text-[#666666]"
              }`
            }
          >
            <span>{item.name}</span>
          </NavLink>
        ))}
      </div>
    </aside>
  );
}
